<div #menuButton class="layout-topbar flex items-center" data-cy="topbar-container">
    <img
        src="assets/layout/images/leaf-logo.svg"
        alt="Azara logo"
        class="inline-block pl-4 pr-8"
        data-cy="topbar-logo"
    />

    <app-tabsbar
        [defaultTabTitle]="'New Action'"
        [defaultTabComponentUrl]="'/new-actions'"
        (tabClicked)="handleTabClicked($event)"
        data-cy="topbar-tabsbar"
    ></app-tabsbar>

    <div class="shrink-0 flex items-center" data-cy="topbar-actions">
        <app-help-menu [pt]="buttonPtOption" data-cy="topbar-help-menu" />
        <app-user-menu
            [userMenuPermissionArgs]="userMenuPermissionArgs()"
            [token]="token"
            [scopedCenter]="this.scopedCenter()"
            [appConfig]="appConfig()"
            [pt]="buttonPtOption"
            (logoutClicked)="handleLogoutClicked()"
            (changeCenterClicked)="handleChangeCentersClicked()"
            (settingsClicked)="handleSettingsClicked()"
            data-cy="topbar-user-menu"
        />
    </div>
</div>
